import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {OptionItem} from '../../shared/ui/option-card/option-card.model';
import {
    ExportNoteComponent,
    ExportNoteTone,
} from '../../shared/ui/export-note/export-note.component';
import {OptionSelectComponent} from '../../shared/ui/option-select/option-select.component';
import {StepCardDirective} from '../step-card/step-card.directive';
import {stepLabels} from '../step-card/step-labels.model';

const noteIcons: Record<ExportNoteTone, string> = {
    info: 'bi-info-circle-fill',
    muted: 'bi-info-circle',
    warning: 'bi-exclamation-triangle-fill',
};

@Component({
    selector: 'app-usage-step',
    standalone: true,
    providers: [
        stepLabels(
            'quickexports_export_step_what_to_do_title',
            'quickexports_export_step_what_to_do_hint',
        ),
    ],
    hostDirectives: [{directive: StepCardDirective, inputs: ['titleKey', 'hintKey']}],
    imports: [TranslatePipe, OptionSelectComponent, ExportNoteComponent],
    template: `
        <app-option-select
            [options]="options()"
            [selectedId]="selectedId()"
            name="export-usage"
            ariaKey="quickexports_export_step_what_to_do_title"
            (optionSelected)="optionSelected.emit($event)" />
        @if (note(); as note) {
            <app-export-note class="d-block mt-3" [icon]="note.icon" [tone]="note.tone">
                {{ note.key | translate: 'online' : 'export' }}
            </app-export-note>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsageStepComponent {
    readonly options = input.required<ReadonlyArray<OptionItem>>();
    readonly selectedId = input.required<string>();

    readonly optionSelected = output<string>();

    protected readonly note = computed(() => {
        const selected = this.options().find(option => option.id === this.selectedId());
        if (selected?.noteKey == null) {
            return null;
        }
        const tone = selected.noteTone ?? 'info';
        return {key: selected.noteKey, tone, icon: noteIcons[tone]};
    });
}
